import React, { Suspense, lazy } from "react"
import ReactDOM from "react-dom"
import { Provider } from "react-redux"
import { PersistGate } from "redux-persist/integration/react"
import { Layout } from "./utility/context/Layout"
import * as serviceWorker from "./serviceWorker"
import { store, persistor } from "./redux/storeConfig/store"
import {I18nextProvider} from 'react-i18next'
import Spinner from "./components/@vuexy/spinner/Fallback-spinner"
import i18n from './i18n'
import "./index.scss"
import "./@fake-db"

const LazyApp = lazy(() => import("./App"))

// configureDatabase()
ReactDOM.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor} >
      <I18nextProvider i18n={i18n}>
          <Suspense fallback={<Spinner />}>
            <Layout>
                <LazyApp />
            </Layout>
          </Suspense>
        </I18nextProvider>
      </PersistGate>
    </Provider>,
  document.getElementById("root")
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
